import React from 'react'
import assets from '../assets'
import './index.css'
import { motion } from 'framer-motion'

const Table1 = ({variants}) => {
  return (
    <div className='section table1'>
        <div className="container-lg flex flexCol alignCenter relative">
            <div className="overflowTable">
                <motion.table
                variants={variants}
                initial={'initial'}
                whileInView={'inView'}
                transition={{ duration: 0.7, delay: .3 }}
                viewport={{ once: true }}
                >
                    <thead>
                    <tr>
                        <th></th>
                        <th>Bitcoin</th>
                        <th>Ethereum</th>
                        <th>Solana</th>
                        <th><img src={assets.logo} alt="Econ" /></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>Transactional Throughput</td>
                        <td>7 tps</td>
                        <td>14 tps</td>
                        <td>65,000 tps</td>
                        <td className='econTable'>200,000 tps</td>
                    </tr>
                    <tr>
                        <td>Transactional Finality</td>
                        <td>60 mins</td>
                        <td>6 mins</td>
                        <td>2 sec</td>
                        <td>&lt;1.98 sec</td>
                    </tr>
                    <tr>
                        <td>Energy Efficient</td>
                        <td>No; ASIC-Optimal</td>
                        <td>No; GPU-Optimal</td>
                        <td>Yes; CPU-Optimal</td>
                        <td>Yes; CPU-Optimal</td>
                    </tr>
                    <tr>
                        <td>Number of Validations</td>
                        <td>3 Pools w/ &gt;51% hash rate</td>
                        <td>2 Pools w/ &gt;51% hash rate</td>
                        <td>&lt;900 nodes</td>
                        <td>Thousands of nodes</td>
                    </tr>
                    <tr>
                        <td>Sybil Protection</td>
                        <td>Proof of Wook</td>
                        <td>Proof of Work</td>
                        <td>Proof of Stake</td>
                        <td>Proof of Stake</td>
                    </tr>
                    <tr>
                        <td>Safety Threshold</td>
                        <td>51%</td>
                        <td>51%</td>
                        <td>51%</td>
                        <td>82% parameterized</td>
                    </tr>
                    </tbody>
                </motion.table>
            </div>
        </div>
    </div>
  )
}

export default Table1